export const categories = [
  {
    slug: 'shuangseqiu',
    name: '双色球',
    icon: 'ri-football-line',
    description: '双色球是中国福利彩票的一种玩法，每周二、四、日开奖',
    frequency: '每周二、四、日',
    latestDraw: '2024135期',
    latestNumbers: ['03', '07', '12', '18', '25', '30'],
    latestBlue: '09',
    prize: '5.2亿',
  },
  {
    slug: 'daletou',
    name: '大乐透',
    icon: 'ri-billiards-line',
    description: '大乐透是体育彩票的旗舰玩法，每周一、三、六开奖',
    frequency: '每周一、三、六',
    latestDraw: '24136期',
    latestNumbers: ['05', '11', '19', '27', '33'],
    latestBlue: '03',
    prize: '8.7亿',
  },
  {
    slug: 'fucai3d',
    name: '福彩3D',
    icon: 'ri-dice-line',
    description: '福彩3D每日开奖，玩法简单中奖率高',
    frequency: '每日开奖',
    latestDraw: '2024334期',
    latestNumbers: ['2', '7', '4'],
    latestBlue: '',
    prize: '0.1亿',
  },
  {
    slug: 'pailiesan',
    name: '排列三',
    icon: 'ri-number-3',
    description: '排列三是体育彩票经典数字玩法，每日开奖',
    frequency: '每日开奖',
    latestDraw: '24335期',
    latestNumbers: ['8', '1', '6'],
    latestBlue: '',
    prize: '0.2亿',
  },
  {
    slug: 'qixingcai',
    name: '七星彩',
    icon: 'ri-star-line',
    description: '七星彩七位数字组合，每周二、五、日开奖',
    frequency: '每周二、五、日',
    latestDraw: '24137期',
    latestNumbers: ['3', '9', '2', '6', '1', '8', '4'],
    latestBlue: '',
    prize: '3.1亿',
  },
];

export const categoryDataTables: Record<string, {
  headers: string[];
  rows: { period: string; date: string; numbers: string[] }[];
}> = {
  shuangseqiu: {
    headers: ['期号', '开奖日期', '红球号码', '蓝球'],
    rows: [
      { period: '2024135', date: '2024-12-03', numbers: ['03', '07', '12', '18', '25', '30', '09'] },
      { period: '2024134', date: '2024-12-01', numbers: ['01', '06', '15', '22', '28', '33', '05'] },
      { period: '2024133', date: '2024-11-28', numbers: ['04', '09', '14', '20', '26', '31', '11'] },
      { period: '2024132', date: '2024-11-26', numbers: ['02', '08', '13', '19', '24', '29', '07'] },
      { period: '2024131', date: '2024-11-23', numbers: ['05', '10', '16', '21', '27', '32', '03'] },
      { period: '2024130', date: '2024-11-21', numbers: ['07', '11', '17', '23', '29', '34', '15'] },
      { period: '2024129', date: '2024-11-18', numbers: ['03', '08', '14', '19', '25', '30', '13'] },
      { period: '2024128', date: '2024-11-16', numbers: ['01', '05', '12', '18', '24', '31', '06'] },
    ],
  },
  daletou: {
    headers: ['期号', '开奖日期', '前区号码', '后区'],
    rows: [
      { period: '24136', date: '2024-12-04', numbers: ['05', '11', '19', '27', '33', '03', '08'] },
      { period: '24135', date: '2024-12-02', numbers: ['02', '08', '16', '24', '30', '05', '10'] },
      { period: '24134', date: '2024-11-30', numbers: ['07', '13', '21', '29', '35', '01', '06'] },
      { period: '24133', date: '2024-11-27', numbers: ['04', '10', '18', '26', '32', '04', '09'] },
      { period: '24132', date: '2024-11-25', numbers: ['01', '09', '17', '25', '31', '02', '07'] },
      { period: '24131', date: '2024-11-22', numbers: ['06', '14', '22', '28', '34', '11', '12'] },
      { period: '24130', date: '2024-11-20', numbers: ['03', '12', '20', '27', '33', '04', '08'] },
      { period: '24129', date: '2024-11-18', numbers: ['08', '15', '23', '30', '35', '06', '10'] },
    ],
  },
  fucai3d: {
    headers: ['期号', '开奖日期', '开奖号码', '试机号'],
    rows: [
      { period: '2024334', date: '2024-12-05', numbers: ['2', '7', '4', '3', '5', '1'] },
      { period: '2024333', date: '2024-12-04', numbers: ['8', '1', '6', '5', '2', '9'] },
      { period: '2024332', date: '2024-12-03', numbers: ['3', '9', '0', '7', '4', '2'] },
      { period: '2024331', date: '2024-12-02', numbers: ['5', '3', '7', '1', '8', '6'] },
      { period: '2024330', date: '2024-12-01', numbers: ['9', '2', '1', '4', '6', '3'] },
      { period: '2024329', date: '2024-11-30', numbers: ['6', '8', '4', '2', '3', '7'] },
      { period: '2024328', date: '2024-11-29', numbers: ['1', '5', '9', '8', '7', '0'] },
      { period: '2024327', date: '2024-11-28', numbers: ['7', '0', '2', '3', '9', '5'] },
    ],
  },
  pailiesan: {
    headers: ['期号', '开奖日期', '开奖号码', '跨度'],
    rows: [
      { period: '24335', date: '2024-12-05', numbers: ['8', '1', '6', '7'] },
      { period: '24334', date: '2024-12-04', numbers: ['2', '9', '3', '7'] },
      { period: '24333', date: '2024-12-03', numbers: ['5', '7', '1', '6'] },
      { period: '24332', date: '2024-12-02', numbers: ['4', '6', '8', '4'] },
      { period: '24331', date: '2024-12-01', numbers: ['9', '0', '5', '9'] },
      { period: '24330', date: '2024-11-30', numbers: ['3', '4', '7', '4'] },
      { period: '24329', date: '2024-11-29', numbers: ['1', '8', '2', '7'] },
      { period: '24328', date: '2024-11-28', numbers: ['6', '3', '9', '6'] },
    ],
  },
  qixingcai: {
    headers: ['期号', '开奖日期', '开奖号码'],
    rows: [
      { period: '24137', date: '2024-12-03', numbers: ['3', '9', '2', '6', '1', '8', '4'] },
      { period: '24136', date: '2024-12-01', numbers: ['7', '1', '5', '3', '8', '2', '9'] },
      { period: '24135', date: '2024-11-29', numbers: ['4', '6', '8', '0', '2', '7', '5'] },
      { period: '24134', date: '2024-11-26', numbers: ['1', '5', '9', '4', '7', '3', '6'] },
      { period: '24133', date: '2024-11-23', numbers: ['8', '2', '0', '5', '3', '9', '1'] },
      { period: '24132', date: '2024-11-20', numbers: ['6', '4', '7', '1', '9', '5', '2'] },
      { period: '24131', date: '2024-11-17', numbers: ['2', '8', '3', '7', '0', '6', '4'] },
      { period: '24130', date: '2024-11-14', numbers: ['5', '9', '1', '4', '6', '8', '3'] },
    ],
  },
};